export const ADD_ACTIVITY = "ADD_ACTIVITY";
export const ADD_ACTIVITIES = "ADD_ACTIVITIES";
export const CLEAR_ACTIVITIES = "CLEAR_ACTIVITIES";
export const REMOVE_ACTIVITY = "REMOVE_ACTIVITY";
export const SET_ACTIVITY_VIEW = "SET_ACTIVITY_VIEW";
export const SET_ACTIVITY_QUERY = "SET_AVTIVITY_QUERY";
